module.exports = __webpack_public_path__ + "assets/img/NPC018.49a8aa4a.png";